<template>
	<div>
		<div v-for="(value, key) in converted_stats" :key="key">
			<div class="elevation-0" style="margin-bottom: 5px; ">
				<div style="color: var(--ks-font-color-title);text-transform: capitalize;">{{key}}</div>
				<k-key-value :items="Object.entries(value).map(([k,v]) => ({key: k, value: v}))" :key-width="'60%'" columns="2">
					<template #value="{value}">
						<k-chip outlined size="xs">{{value}}</k-chip>
					</template>
				</k-key-value>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		"stats": {
			type: Object
		},
		"type": {
			type: String,
			default: "all"
		},
		"adaptive-bitrate": {
			type: Number,
			default: -1
		}
	},
	methods: {		
	},
	computed: {
		converted_stats () {
			var ret = {}
			ret["general"] = {};
			ret["general"]["latency"] = _.get(this.stats, ["recv","msTsbPdDelay"], null);
			if (this.adaptiveBitrate > -1) {
				ret["general"]["adaptive bitrate"] = (this.adaptiveBitrate / 1000000.0).toFixed(2);
			}

			for (var key in this.stats) {
				if (this.type == "send" && (key == "recv")) continue;
				if (this.type == "recv" && (key == "send")) continue;
				if (typeof(this.stats[key]) === "object") {
					ret[key] = this.stats[key]
				} else {
					ret["general"][key] = this.stats[key];
				}
			}
			return ret;
		}
	}
}
</script>
<style scoped>
	.v-chip--small {
		height: 18px !important;
		margin: 1.8px;
	}
</style>